export { default as Img200 } from './processed/200/Thor-Ragnarok.jpg';
export { default as Img400 } from './processed/400/Thor-Ragnarok.jpg';
export { default as Imgthumb } from './processed/thumb/Thor-Ragnarok.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Thor-Ragnarok.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Thor-Ragnarok.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      245,
      213,
      9
    ],
    "_population": 258,
    "_hsl": [
      0.1440677966101695,
      0.9291338582677166,
      0.4980392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      250,
      239,
      87
    ],
    "_population": 2117,
    "_hsl": [
      0.1554192229038855,
      0.9421965317919075,
      0.6607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      133,
      14,
      17
    ],
    "_population": 52,
    "_hsl": [
      0.9957983193277311,
      0.8095238095238094,
      0.2882352941176471
    ]
  },
  "Muted": {
    "_rgb": [
      147,
      95,
      98
    ],
    "_population": 158,
    "_hsl": [
      0.9903846153846154,
      0.2148760330578512,
      0.4745098039215686
    ]
  },
  "LightMuted": {
    "_rgb": [
      152,
      203,
      196
    ],
    "_population": 453,
    "_hsl": [
      0.47712418300653603,
      0.32903225806451597,
      0.696078431372549
    ]
  },
  "DarkMuted": {
    "_rgb": [
      41,
      71,
      56
    ],
    "_population": 181,
    "_hsl": [
      0.4166666666666667,
      0.26785714285714285,
      0.2196078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Thor-Ragnarok.js